<button
  *ngIf="windowBeacon"
  class="btn btn-help"
  (click)="toggleBeacon('toggle')"
>
  <span>
    <tr-icon
      [icon]="icon.question"
      [color]="color.white"
      [size]="size.large"
    ></tr-icon>
  </span>
</button>
